module.exports = ".previous {\r\n    color: blue;\r\n    cursor: pointer;\r\n    text-decoration: underline;\r\n}\r\n\r\n.backHeader {\r\n    margin-top: 59px;\r\n    text-align: right;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/transaction-history/transaction-list-user/transaction-list-user.component.css
// module id = ./src/app/transaction-history/transaction-list-user/transaction-list-user.component.css
// module chunks = main